import { Logo, NavigationMenu, UserMenu } from "@appretio/ui-kit";
import { RouteObject, useNavigate } from "react-router-dom";
import { buildNavItems } from "../../utils/buildNavItems";
import {
  headerLogo,
  layoutHeader,
  navigationItem,
  navigationMenu,
  userMenu
} from "./AppLayout.css";

export interface AppHeaderProps {
  /*
   * Routes that drive the top navigation
   */
  navRoutes: RouteObject[];
  /*
   * Current location pathname (e.g., "/assortment/items")
   */
  pathname: string;
  /*
   * Current user's display name
   */
  userName: string;
  /*
   * Sign-out handler
   */
  onSignOut: () => void;
}

export function AppHeader({
  navRoutes,
  pathname,
  userName,
  onSignOut
}: AppHeaderProps) {
  const navigate = useNavigate();

  const sections = navRoutes.map((r) =>
    buildNavItems(r, `/${r.path ?? ""}`, navigate)
  );

  return (
    <header className={layoutHeader} data-testid="app-header">
      <div className={headerLogo}>
        <Logo />
      </div>

      <div className={navigationMenu}>
        {sections.map((sec, index) => {
          const groupKey = `group-${index} ${sec.groupLabel}`;

          const allItems = sec.items.flatMap((item) => [
            item,
            ...(item.children ?? [])
          ]);

          const selectedItem = allItems
            .filter((item) => pathname.startsWith(item.url))
            .sort((a, b) => b.url.length - a.url.length)[0];

          return (
            <div className={navigationItem} key={groupKey}>
              <NavigationMenu
                key={groupKey}
                items={sec.items}
                groupPlaceholder={sec.groupLabel}
                selectedItem={selectedItem}
              />
            </div>
          );
        })}
      </div>

      <div className={userMenu}>
        <UserMenu
          aria-label="User menu"
          userName={userName}
          items={[
            { label: "Settings", icon: "settings", onClick: () => {} },
            { label: "Sign out", icon: "log-out", onClick: onSignOut }
          ]}
        />
      </div>
    </header>
  );
}
